import { useContext, useEffect, useRef, useState } from "react";

const PlusMinusSelect = (props) => {

    // const [order, setOrder] = useContext(OrderContext);

    const [currentMount, setCurrentMount] = useState(props.Mount != null ? props.Mount : 1);

    const [minCount, setMinCount] = useState(props.minCount != null ? props.minCount : 0);


    useEffect(() => {
        setCurrentMount(props.Mount)
      
    }, [props.Mount, props.minCount])

    const addToMount = () => {

        let temp = currentMount + 1;
        setCurrentMount(temp);
        props.theVal(temp);
    }

    const lessToMount = () => {

        if (currentMount - 1 >= minCount) {

            setCurrentMount(currentMount - 1);
            
            props.theVal(currentMount - 1);
        }
    }


    return (
        <div className={`${props.css}`}>
            {/* <div className={"mountLn"}>כמות</div> */}
            <div className={`${props.plusBtnStyle} pointing`} onClick={() => addToMount()}>+</div>
            <div className={`${props.mountNumStyle} regularPoint`}>
                {currentMount}
            </div>
            <div className={`${props.minusBtnStyle} pointing`} onClick={() => lessToMount()}>-</div>
        </div>
    );
}

export default PlusMinusSelect;
